import React, { useState, useEffect } from 'react';
import { oneOf, node } from 'prop-types';

const isDev = process.env.NODE_ENV === 'development';

const initialConsent = {
  necessary: true,

  // Default to full consent in dev mode to avoid hiding content
  preferences: isDev,
  statistics: isDev,
  marketing: isDev,
};

const useCookieConsent = () => {
  const [consent, setConsent] = useState(initialConsent);

  const updateConsent = () => {
    if (window?.tarteaucitron?.state) {
      setConsent(window?.tarteaucitron?.state);
    } else {
      setConsent(initialConsent);
    }
  };

  // Set consent values on initial load
  useEffect(() => {
    updateConsent();
  }, []);

  // Add event if consent is changed as user is browsing the website
  // https://www.cookiebot.com/en/developer/
  useEffect(() => {
    const initEventName = 'CookiebotOnLoad';
    window.addEventListener(initEventName, updateConsent);
    return () => {
      window.removeEventListener(initEventName, updateConsent);
    };
  });

  return consent;
};

const CookieConsent = props => {
  const { category, fallback, children } = props;
  const consent = useCookieConsent();

  const hasConsent = consent[category] === true;
  return hasConsent ? <>{children}</> : <>{fallback}</>;
};

export default CookieConsent;
